import {combineReducers} from 'redux';
import {
  SET_TOURNAMENT_ID,
  SET_RETURNING_TO_CALENDAR
} from './constants';
import home from './home/reducer';
import payment from './checkout/reducer';
import scheduler from './scheduler/reducer';
import manage from './manage/reducer';
import shared from './shared/reducer';
import rostercheckout from './rostercheckout/reducer';
import accountCreated from './accountCreated/reducer';

const initialState = {
  tournamentId: '',
  tournamentName: '',
  tournamentPhoneNumber: '',
  marketingMessage: '',
  rosterMessage: '',
  canCaptainPurchase: false,
  captainPurchaseReason: '',
  showCalculatedDivisionToCaptain: false,
  returningToCalendar: false,
  tournamentStripeKey: '',
  requireRosterBeforeCheckout: false,
  blockFailedDivisionCalculation: false,
  paymentSuccessMessage: '',
  paymentFailureMessage: '',
  allowChangeBetweenFreeEvents: false
};

export const base = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_RETURNING_TO_CALENDAR:{
      return {
        ...state,
        returningToCalendar: true
      };
    }
    case SET_TOURNAMENT_ID:
      return {
        ...state,
        ...{
          tournamentId: payload.id,
          tournamentName: payload.name,
          tournamentPhoneNumber: payload.phoneNumber,
          marketingMessage: payload.marketingMessage,
          rosterMessage: payload.rosterMessage,
          canCaptainPurchase: payload.canCaptainPurchase,
          canCaptainManage: payload.canCaptainManage,
          captainPurchaseReason: payload.captainPurchaseReason,
          showCalculatedDivisionToCaptain: payload.showCalculatedDivisionToCaptain,
          tournamentStripeKey: payload.stripePublishableKey,
          requireRosterBeforeCheckout: payload.requireRosterBeforeCheckout,
          blockFailedDivisionCalculation: payload.blockFailedDivisionCalculation,
          paymentSuccessMessage: payload.paymentSuccessMessage,
          paymentFailureMessage: payload.paymentFailureMessage,
          captainPassesAgeRestrictions: payload.captainPassesAgeRestrictions,
          allowChangeBetweenFreeEvents : payload.allowChangeBetweenFreeEvents
        }
      };

    default:
      return state;
  }
};

const registration = combineReducers({
  base,
  home,
  payment,
  scheduler,
  manage,
  shared,
  rostercheckout,
  accountCreated
});

export default registration;



// WEBPACK FOOTER //
// ./src/features/registration/reducer.js